module.exports = __webpack_public_path__ + "mainassets/img/chevron-up.6465d575.svg";